module.exports = __webpack_public_path__ + "static/media/ie.798a56e0.svg";